import { render, staticRenderFns } from "./roleRequest.vue?vue&type=template&id=f750019a&"
import script from "./roleRequest.vue?vue&type=script&lang=ts&"
export * from "./roleRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports